import { createContext, useReducer } from "react";
import chordReducer from "../reducers/chord-reducer";

const defaultQualityValue = "Quality";

export const QualityContext = createContext();
export const QualityProvider = ({ children }) => {
  const [qualityValue, dispatch] = useReducer(chordReducer, defaultQualityValue);
  return (
    <QualityContext.Provider value={{ qualityValue, dispatch }}>
      {children}
    </QualityContext.Provider>
  );
};
